import React from 'react';
import { AlertCircle, Home, Clock, Frown } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainPointSection() {
  return <section className="py-20 bg-white" data-id="element-203">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-205">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-50 text-red-600 mb-6" data-id="element-206">
            <AlertCircle size={32} data-id="element-207" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-208">
            Does This Sound Familiar?
          </h2>
        </motion.div>

        <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-209">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-210">
            You pull into your driveway after a long day of work…
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="font-medium text-gray-900" data-id="element-211">
            And instead of feeling proud of your home, you feel a quiet
            embarrassment.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-gray-50 border-l-4 border-[#C41E24] p-6 rounded-r-lg my-8" data-id="element-212">
            <p className="mb-4" data-id="element-213">
              The patio is crumbling. The landscaping is overgrown. The mulch
              beds look like nobody's touched them in years.
            </p>
            <p data-id="element-214">
              You've been meaning to fix it — but every contractor you've called
              either <strong className="text-[#C41E24]" data-id="element-215">never showed up</strong>
              , gave you an{' '}
              <strong className="text-[#C41E24]" data-id="element-216">insane quote</strong>, or did{' '}
              <strong className="text-[#C41E24]" data-id="element-217">
                halfway work and disappeared
              </strong>
              .
            </p>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} data-id="element-218">
            So the yard stays the same. Another summer goes by.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} data-id="element-219">
            And you're left staring at an outdoor space that has so much
            potential — but never becomes what you know it could be.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="mt-10 pt-8 border-t border-gray-200 text-center" data-id="element-220">
            <p className="text-xl font-serif text-[#1B4332] italic" data-id="element-221">
              "You're not alone. This is the story of almost every homeowner in
              Northeast Ohio."
            </p>
            <p className="mt-4 font-semibold text-gray-900" data-id="element-222">
              The real problem isn't your yard. It's that you haven't found the
              right team yet.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}